import axios from 'axios'
import APP_CONSTANT from '../../config/constants'

const allAxiosCommonRequest = async function (props = {}) {
    let token = localStorage.getItem('isloggedIn')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNumber')
    let congData =
    {
        ...props.Items
    }
    let response = 
    await axios.request({
        baseURL:`${process.env.REACT_APP_SCCT_BASE_URL}/transporter-allocation`,//'https://dev-commongateway.elixia.tech',
        url: '/aws/dashboard',
        method: props.method,
        data: props.method != 'get' ? congData : '',   
    })
    let resp = new Promise((resolve, reject) => {
        if (response.status === 200) {
            resolve(response)
        } else {
            reject(response)
        }
    })
    return resp;
}
export default allAxiosCommonRequest